'use strict';

define([], function () {
    return document.createElement('video');
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/utils/video.js
 ** module id = 75
 ** module chunks = 0
 **/